export class Treatment {
  type?: string;
  'created_at': string;
  'deleted_at': string;
  'detection': any;
  'detection_time': any;
  'drug_name': string;
  // 'drug_brand': string;
  'horse_id': number;
  'id': number;
  'other_route': string;
  'prescriptions': [Prescription];
  'reason': string;
  'request': any;
  'request_id': number;
  'route': string;
  'status': string;
  'updated_at': string;
  'vetclinic_id': string;
  'withdrawal': string;
  'start_date': string;

  'drug': any;
  'quantity': number;
  'other_quantity': string;
  'quantity_measure': any;
  'duration': number;
  'src': any;
  'srcs': any[];
  'horse': any;
  "intra_articular_infoA": string;
  "intra_articular_infoB": string;
  "intra_articular_other_info": string;
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/classes/treatment.ts